import { LANDING_PAGE } from './types';

export function requestLandingPage({ path, host }) {
  // the Storyblok path includes the slugified domain name,
  // e.g. deliveroo.co.uk -> deliveroo-co-uk
  const slugifiedDomain = host.replace(/\./g, '-');
  return (dispatch) =>
    dispatch({
      type: LANDING_PAGE,
      story: {
        path: `${slugifiedDomain}/${path}`,
      },
    });
}
